export default __webpack_public_path__ + "static/media/filter-hide-arrow.b130f3ca.svg";